import axios from 'axios'
import tokenClear from '@/helper/eraseToken'

export const dashboard = {
    mixins: [tokenClear],
    methods: {
        // data detail pegawai
        async getDetailPegawai(pegawai_id) {
            try {
                let response = await axios.get('/api/data-induk/kepegawaian/pegawai/' + pegawai_id)
                const items = response.data.data
                this.detailPegawai = items
            } catch (error) {
                if (error.response.status === 401) {
                    // token clear mixins
                    this.clearAll()       
                } else {
                    this.$swal({
                        title: "Terjadi Masal",
                        text: "Silahkan hubungi Administrator.",
                        icon: 'error',
                        buttonsStyling: false,
                        confirmButtonText: "OKE",
                        confirmButtonClass: "btn m-r-5 btn-primary",
                    })
                }
            }
        }
    }
}

export default dashboard